import PropTypes from 'prop-types';
import { components } from 'react-select';
import { Link } from 'gatsby-plugin-react-i18next';

import Indicator from '../images/dropdown-carat.inline.svg';
import Clear from '../images/clear-icon.inline.svg';

export const DropdownIndicator = (props) => {
	return (
		<components.DropdownIndicator {...props}>
			<Indicator />
		</components.DropdownIndicator>
	);
};

export const ClearIndicator = (props) => {
	return (
		<components.ClearIndicator {...props}>
			<Clear />
		</components.ClearIndicator>
	);
};

export const OptionAsLink = (props) => (
	<Link className="link link--no-underline" to={`${props.value}/`}>
		<components.Option {...props} />
	</Link>
);

OptionAsLink.propTypes = {
	value: PropTypes.string.isRequired,
};

export const selectStyles = {
	menu: (provided) => ({
		...provided,
		width: 250,
		fontSize: '1rem',
		fontFamily: 'Poppins',
		zIndex: 1001,
	}),
	menuList: () => ({
		border: 'none',
	}),
	option: (provided, state) => ({
		...provided,
		border: 'none',
		cursor: 'pointer',
		padding: '1.125rem',
		background: state.isFocused ? '#1B2B4C' : '#ffffff',
		color: state.isFocused ? '#ffffff' : '#111111',
	}),
	control: () => ({
		width: 250,
		height: 56,
		margin: 0,
		paddingLeft: '1rem',
		cursor: 'pointer',
		opacity: 1,
		border: '1px solid #1B2B4C',
		borderRadius: '4px',
		display: 'flex',
		boxShadow:
			'0px 4px 4px rgba(51, 51, 51, 0.04), 0px 4px 16px rgba(51, 51, 51, 0.08)',
	}),
	placeholder: () => ({
		opacity: 0.75,
		padding: 0,
		position: 'relative',
		top: '-.75rem',
	}),
	dropdownIndicator: (provided, state) => ({
		...provided,
		transform: state.selectProps.menuIsOpen && 'rotate(90deg)',
		transition: 'all .2s ease-in-out',
		position: 'absolute',
		right: '.75rem',
		top: 0,
		bottom: 0,
		margin: 'auto',
		padding: 0,
		alignItems: 'center',
	}),
	clearIndicator: (provided) => ({
		...provided,
		position: 'relative',
		right: '2rem',
		alignItems: 'center',
		height: '100%',
	}),
	indicatorSeperator: () => ({
		display: 'none',
	}),
	indicatorsContainer: () => ({
		padding: '0',
	}),
	singleValue: (provided) => {
		const transition = 'opacity 300ms';
		return { ...provided, transition };
	},
};

export const selectStylesMob = {
	...selectStyles,
	control: () => ({
		width: 100,
		height: 56,
		margin: 0,
		paddingLeft: '.25rem',
		cursor: 'pointer',
		opacity: 1,
		border: '1px solid #1B2B4C',
		borderRadius: '4px',
		display: 'flex',
		boxShadow:
			'0px 4px 4px rgba(51, 51, 51, 0.04), 0px 4px 16px rgba(51, 51, 51, 0.08)',
	}),
	clearIndicator: (provided) => ({
		...provided,
		position: 'relative',
		right: '.5rem',
		alignItems: 'center',
		height: '100%',
	}),
	dropdownIndicator: (provided) => ({
		...provided,
		display: 'none',
	}),
	menu: (provided) => ({
		...provided,
		width: 100,
		fontSize: '1rem',
		fontFamily: 'Poppins',
		zIndex: 1001,
	}),
	placeholder: () => ({
		opacity: 0.75,
		padding: 0,
		position: 'relative',
		top: '-.75rem',
		fontSize: '.675rem',
	}),
};
